$exso_logo $mol_image
	uri \/exso/logo/logo.svg
